import { render, staticRenderFns } from "./starContent.vue?vue&type=template&id=1a5c2be2&scoped=true"
import script from "./starContent.vue?vue&type=script&lang=js"
export * from "./starContent.vue?vue&type=script&lang=js"
import style0 from "./starContent.vue?vue&type=style&index=0&id=1a5c2be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c2be2",
  null
  
)

export default component.exports